import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fhl",
  "use": "icon-fhl-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol class=\"custom-svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 14\" id=\"icon-fhl\">\r\n\t<path d=\"M12.384 1.95034H4.131V0L0 2.65517L4.131 5.31034V3.36966H12.384C14.859 3.36966 16.677 5.13655 16.677 7.97517C16.677 10.8138 14.859 12.5807 12.384 12.5807H7.434C7.101 12.5807 6.777 12.9379 6.777 13.2855C6.777 13.6331 7.11 13.9903 7.434 13.9903H12.384C15.525 13.9903 18 11.5959 18 7.96552C18 4.33517 15.525 1.95034 12.384 1.95034Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol